import { render, staticRenderFns } from "./MapRed.vue?vue&type=template&id=6306e85b"
import script from "./MapRed.vue?vue&type=script&lang=js"
export * from "./MapRed.vue?vue&type=script&lang=js"
import style0 from "./MapRed.vue?vue&type=style&index=0&id=6306e85b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports